module.exports = __webpack_public_path__ + "static/media/winbing-whatsapp.e4428430.jpg";